/* eslint-disable max-len */
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutMainComponent } from './components/layout/pages/layout-main/layout-main.component';
import { Page404PageComponent } from './components/layout/pages/page404.page/page404.page.component';
import { AuthenticationGuard } from './components/page/guards/authentication.guard';
import { PermissionGuard } from './components/shared/sharedModules/permission/permission.guard';

const routes: Routes = [
  {
    path: '',
    component: LayoutMainComponent,
    children: [
      {
        path: 'domicilios',
        loadChildren: () =>
          import('./components/delivery/delivery.module').then(m => m.DeliveryModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [PermissionGuard],
      },
      {
        path: 'operacion',
        loadChildren: () =>
          import('./components/operations/operations.module').then(m => m.OperationsModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [PermissionGuard],
      },
      {
        path: 'historico',
        loadChildren: () =>
          import('./components/historical/historical.module').then(m => m.HistoricalModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [PermissionGuard],
      },
      {
        path: 'puntos',
        loadChildren: () => import('./components/points/points.module').then(m => m.PointsModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [PermissionGuard],
      },
      {
        path: 'masivos',
        loadChildren: () =>
          import('./components/massive/massive.module').then(m => m.MassiveModule),
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'demo',
        loadChildren: () => import('./components/demo/demo.module').then(m => m.DemoModule),
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'page',
        loadChildren: () => import('./components/page/page.module').then(m => m.PageModule),
      },
      {
        path: 'cedi',
        loadChildren: () =>
          import('./components/cedi-store/cedi-store.module').then(m => m.CediStoreModule),
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'usuarios',
        loadChildren: () => import('./components/users/users.module').then(m => m.UsersModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [PermissionGuard],
      },
      {
        path: 'crear-cuenta',
        loadChildren: () => import('./components/auth/auth.module').then(m => m.AuthModule),
      },
      {
        path: 'same-next-day',
        loadChildren: () =>
          import('./components/same-next-day/same-next-day.module').then(m => m.SameNextDayModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [PermissionGuard],
      },
      {
        path: 'express',
        loadChildren: () =>
          import('./components/express-basic/express-basic.module').then(m => m.ExpressBasicModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [PermissionGuard],
      },
      {
        path: 'direcciones-favoritas',
        loadChildren: () =>
          import('./components/favorite-address/favorite-address.module').then(
            m => m.FavoriteAddressModule
          ),
        canActivate: [AuthenticationGuard],
        canActivateChild: [PermissionGuard],
      },
      {
        path: 'metodos-de-pago',
        loadChildren: () =>
          import('./components/payments/payments.module').then(m => m.PaymentsModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [PermissionGuard],
      },
      {
        path: 'recaudos',
        loadChildren: () =>
          import('./components/receipts/receipts.module').then(m => m.CollectionsModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [PermissionGuard],
      },
      {
        path: 'mi-perfil',
        loadChildren: () =>
          import('./components/profile/profile.module').then(m => m.ProfileModule),
        canActivate: [AuthenticationGuard],
        canActivateChild: [PermissionGuard],
      },
      {
        path: 'auto-verificacion',
        children: [
          {
            path: 'crear-cuenta',
            loadChildren: () => import('./components/auth/auth.module').then(m => m.AuthModule),
          },
        ],
      },
      {
        path: 'ext',
        loadChildren: () => import('./components/public/public.module').then(m => m.PublicModule),
      },
      {
        path: 'co',
        children: [
          {
            path: 'ext',
            loadChildren: () =>
              import('./components/public/public.module').then(m => m.PublicModule),
          },
          {
            path: 'ext',
            loadChildren: () =>
              import('./components/express-basic/express-basic.module').then(
                m => m.ExpressBasicModule
              ),
          },
        ],
      },
      {
        path: 'mx',
        children: [
          {
            path: 'ext',
            loadChildren: () =>
              import('./components/public/public.module').then(m => m.PublicModule),
          },
          {
            path: 'ext',
            loadChildren: () =>
              import('./components/express-basic/express-basic.module').then(
                m => m.ExpressBasicModule
              ),
          },
        ],
      },

      {
        path: '',
        loadChildren: () => import('./components/layout/layout.module').then(m => m.LayoutModule),
        canActivate: [AuthenticationGuard],
      },
      {
        path: '**',
        component: Page404PageComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
